/**
 * Marca neutra de AiteaView: respaldo embebido cuando el backend no devuelve
 * marca (sin fichero, inválida o sin red). Debe coincidir con `NEUTRAL` de
 * `branding/schema.py` del backend. Reproduce el aspecto de AiteaView sin
 * personalizar.
 */
export const LANGUAGES = ['es', 'en', 'fr', 'ca'];

// Términos renombrables (contrato con `branding/schema.py`: TERM_KEYS).
export const TERM_KEYS = [
  'portfolio',
  'space',
  'spaces',
  'building',
  'buildings',
  'subbuilding',
  'subbuildings',
  'floor',
  'floors',
  'client',
  'clients',
];

export const NEUTRAL_BRANDING = {
  version: 1,
  name: 'AiteaView',
  title: 'AiteaView',
  favicon: null,
  // Sin ruta: logos e imagen de fondo neutros los pinta el SCSS del tema
  // (`url($logo-path)`, `url($background-fixed)`), que webpack empaqueta con
  // hash. Una ruta `/assets/...` en tiempo de ejecución no existe en el build.
  logos: {
    login: null,
    sidebar: null,
    mobile: null,
  },
  colors: {
    primary: '#53565A',
    foreground: '#EAE9E1',
    text: '#ffffff',
    page_text: '#53565A',
    theme_color_1: '#00AABA',
    theme_color_2: '#65CBD5',
    theme_color_3: '#AFBFBC',
    theme_color_4: '#9ADDE4',
    theme_color_5: '#60a07d',
    theme_color_6: '#F6D352',
  },
  background: {
    color: '#F6F6F6',
    gradient: null,
    image: null,
  },
  card: {
    bg: 'rgba(0, 0, 0, 0.10)',
    radius: '1.5rem',
    border_color: null,
    border_width: '0',
    blur: '10px',
  },
  font: null,
  default_language: null,
  terms: {},
  // Opciones del despliegue (contrato con FEATURE_KEYS de branding/schema.py).
  features: { sso_login: true },
};
